import DeepSleepModal from './deep-sleep-modal.connect'

export default DeepSleepModal
